"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.MeetYourMatch = void 0;
var _meetYourMatch = _interopRequireDefault(require("./components/meet-your-match"));
exports.MeetYourMatch = _meetYourMatch["default"];